import { Subject ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class ModalService {
    modalVisibilityChanged$: Observable<boolean> = new Observable();
    modalOkClicked$: Observable<any> = new Observable();
    hideModal$: Observable<any> = new Observable();

    private modalVisibilityChangedSubject = new Subject<boolean>();
    private modalOkClickedSubject = new Subject();
    private hideModalSubject = new Subject();

    constructor() {
        this.modalVisibilityChanged$ = this.modalVisibilityChangedSubject.asObservable();
        this.modalOkClicked$ = this.modalOkClickedSubject.asObservable();
        this.hideModal$ = this.hideModalSubject.asObservable();
    }

    changeModalVisibility(state: boolean) {
        this.modalVisibilityChangedSubject.next(state);
    }

    acceptModal(data?: any) {
        this.modalOkClickedSubject.next(data);
    }

    hideModal() {
        this.hideModalSubject.next();
    }
}